import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCategories, getFinishedProducts, getMaterials, getPreparedMaterials, slugifyText } from "../../configs/productsConfig";
import Header from "../../components/Header";
import { ProductCard } from "../../components/Cards";
import CategoryButton from "../../components/CategoryButton";
import { UserContext } from "../../configs/UserContext";
import { Helmet } from "react-helmet-async";

function Products() {

    const { tableName } = useParams();
    const [products, setProducts] = useState([]);
    const [headerName, setHeaderName] = useState('');
    const [headerDescription, setHeaderDescription] = useState('');
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [searchString, setSearchString] = useState("");
    const [sortOption, setsortOption] = useState('Legújabb elől');
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const { user } = useContext(UserContext);

    const handleCategoryClick = (categoryName) => {
        if(categoryName === selectedCategory){
            setSelectedCategory('');
        } else {
            setSelectedCategory(categoryName);
            const filteredByCategory = products.filter(product => product.category_name === categoryName);
            setFilteredProducts(filteredByCategory);
        };
    }

    const handleDeleteProduct = (productId) => {
        const updatedProducts = products.filter(product => product.product_id !== productId);
        setProducts(updatedProducts);
    };

    useEffect(() => {

        setProducts([]);
        setSelectedCategory('');
        const fetchData = async () => {
            try {
                const categories = await getCategories(tableName);
                setCategories(categories)
                if (tableName === 'finished_products') {
                    const data = await getFinishedProducts();
                    setProducts(data);
                } else if (tableName === 'prepared_materials') {
                    const data = await getPreparedMaterials();
                    setProducts(data);
                } else if (tableName === 'materials') {
                    const data = await getMaterials();
                    setProducts(data);
                }

            } catch (error) {
                console.error(error);
            }
        };

        fetchData();

        getHeaderText();

    }, [tableName]);

    const getHeaderText = () => {
        if (tableName === 'finished_products') {
            setHeaderName('Kézzel készült dekorációk otthonodba');
            setHeaderDescription('Egy tömeggyártás és uniformitás uralta világban a kézzel készített tárgyak egyedi és autentikus kincsekként tűnnek ki. Ezek az egyedi darabok értékes emlékekké válnak, jelentéssel, érzelemmel telítődnek és kézzelfogható emlékeztetőként szolgálnak az örömre és szenvedélyre, amely létrehozásukba került.');
        } else if (tableName === 'prepared_materials') {
            setHeaderName('Kreatív csomagok egyedi alkotások elkészítéséhez');
            setHeaderDescription('A kézművesek igényei és preferenciái sokféleséget mutatnak, ezért a kínálatot úgy állítottam össze, hogy különböző készségszintek, művészeti stílusok és projekttípusok számára is megfelelő legyen. Legyél tapasztalt kézműves vagy kezdő, biztosan megtalálod a tökéletes csomagokat, hogy életre kelthesd elképzeléseidet.');
        } else if (tableName === 'materials') {
            setHeaderName('Kreatív és kézműves alapanyagok');
            setHeaderDescription('Az inspiráló anyagok és kiegészítők lehetővé teszik, hogy életre keltsd az ötleteidet. Akár új projekteken dolgozol, akár a meglévő készségeidet szeretnéd továbbfejleszteni, széles választékomban biztosan megtalálod a megfelelő alapokat egyedi és különleges alkotásokhoz.');
        }
    };

    function searchProduct(productsArray, searchInput) {
        setSearchString(searchInput);
        const array = productsArray;
        const searchString = searchInput.toLowerCase();
        setFilteredProducts(array.filter((product) => product.name.toLowerCase().includes(searchString)));
    };

    const handleSortChange = (event) => {
        const option = event.target.value;
        setsortOption(event.target.value);

        let sortedData = [...products];

        switch (option) {
            case 'Ár szerint növekvő':
                sortedData.sort((a, b) => a.price - b.price);
                break;
            case 'Ár szerint csökkenő':
                sortedData.sort((a, b) => b.price - a.price);
                break;
            case 'ABC sorrend':
                sortedData.sort((a, b) => a.name.localeCompare(b.name));
                break;
            case 'Legújabb elől':
                sortedData.sort((a, b) => new Date(b.upload_date) - new Date(a.upload_date));
                break;
            case 'Kiemeltek':
                sortedData.sort((a, b) => b.is_highlighted - a.is_highlighted);
                break;
            default:
                break;
        }

        setProducts(sortedData);
    };


    return (
        <div className='container-fluid p-0'>
            <Helmet>
                <title>{headerName} – Kreatív Örömök</title>
                <meta name="description" content={headerDescription} />

                <script type="application/ld+json">
                    {`
                    {
                    "@context": "https://schema.org",
                    "@type": "ItemList",
                    "itemListElement": [
                        ${products.map((product, index) => `{
                        "@type": "ListItem",
                        "position": ${index + 1},
                        "url": "https://kreativoromok.hu/products/${tableName}/${slugifyText(product.name)}__${product.product_id}"
                        }`).join(",")}
                    ]
                    }
                    `}
                </script>

            </Helmet>
            <Header pageName={headerName} headerText={headerDescription} />

            <div className="container-lg d-flex flex-wrap justify-content-center gap-2">
                {categories.map((category, index) => (
                    <CategoryButton
                        key={index}
                        category={category}
                        filter={handleCategoryClick}
                    />
                ))}
            </div>


            <div className="container-lg d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 pb-3 border-bottom mb-3">

                {/* Keresés */}
                <div className="w-100 d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-2">
                    <label className="fw-medium">Keresés:</label>
                    <input
                        type="text"
                        value={searchString}
                        className="form-control"
                        onChange={(e) => searchProduct(products, e.target.value)}
                        placeholder="Termék keresése..."
                    />
                </div>

                {/* Rendezés */}
                <div className="col-12 col-md-4">
                    <select
                        className="form-select fs-6"
                        value={sortOption}
                        onChange={handleSortChange}
                    >
                        <option value="Ár szerint növekvő">Ár szerint növekvő</option>
                        <option value="Ár szerint csökkenő">Ár szerint csökkenő</option>
                        <option value="ABC sorrend">ABC sorrend</option>
                        <option value="Legújabb elől">Legújabb elől</option>
                        {user === "admin" && (
                            <option value="Kiemeltek">Kiemeltek előre</option>
                        )}
                    </select>
                </div>

            </div>


            <div className="container-lg d-flex flex-wrap gap-4 p-1 justify-content-center mb-4">
                {(searchString !== "" || selectedCategory !== "")
                    ? filteredProducts.map((product) => (
                        <ProductCard
                            key={product.product_id}
                            product={product}
                            tableName={tableName}
                            onDelete={() => handleDeleteProduct(product.product_id)}
                        />
                    ))
                    : products.map((product) => (
                        <ProductCard
                            key={product.product_id}
                            product={product}
                            tableName={tableName}
                            onDelete={() => handleDeleteProduct(product.product_id)}
                        />
                    ))}
            </div>

        </div>
    );
};

export default Products;
